import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { useAudioPlayerControls } from 'shared/hooks/useAudioPlayer';
import { getPublishedEpisodes } from 'shared/data/episodeRepository';

const navItems = [
  { to: '/', key: 'nav.home' as const },
  { to: '/episodes', key: 'nav.episodes' as const },
  { to: '/about', key: 'nav.about' as const },
  { to: '/community', key: 'nav.community' as const },
];

export function Header() {
  const { t } = useTranslation();
  const { play } = useAudioPlayerControls();
  const latestPlayable = getPublishedEpisodes().find((ep) => Boolean(ep.audioUrl));

  return (
    <nav role='navigation' className="fixed top-0 w-full z-50 bg-surface/80 backdrop-blur-xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] grid grid-cols-[auto_1fr_auto] lg:grid-cols-[1fr_auto_1fr] items-center px-6 lg:px-12 py-6">
      <Link
        to="/"
        className="font-serif italic text-2xl text-tertiary hover:scale-105 transition-transform duration-300"
      >
        {t('podcast.title')}
      </Link>

      {/* Desktop Nav — hidden on mobile, bottom nav handles it */}
      <div className="hidden md:flex justify-center items-center gap-8">
        {navItems.map(({ to, key }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `font-serif tracking-tight text-lg transition-colors hover:text-tertiary focus-visible:ring-2 focus-visible:ring-tertiary focus-visible:ring-offset-2 focus-visible:outline-none focus-visible:rounded ${
                isActive
                  ? 'text-tertiary border-b-2 border-tertiary pb-1'
                  : 'text-on-surface-variant'
              }`
            }
          >
            {t(key)}
          </NavLink>
        ))}
      </div>

      {latestPlayable ? (
        <div className="flex justify-end">
          <Button
            variant="gold"
            size="sm"
            className="hidden md:inline-flex"
            onClick={() => play(latestPlayable)}
          >
            {t('listenNow')}
          </Button>
          <IconButton
            variant="gold"
            size="md"
            icon="headphones"
            iconWeight="bold"
            className="md:hidden"
            aria-label={t('listenNow')}
            onClick={() => play(latestPlayable)}
          />
        </div>
      ) : null}
    </nav>
  );
}
